import { useId } from 'react';
import { Description, Label, LabelText, RadioControl, TextStack } from './RadioButton.styles';
import type { RadioButtonProps } from './RadioButton.types';

export function RadioButton({
  name,
  value,
  label,
  description,
  checked,
  onChange,
  disabled,
  error,
  variant = 'default',
}: RadioButtonProps) {
  const labelId = useId();
  const descriptionId = useId();

  return (
    <Label data-disabled={disabled} data-variant={variant} data-selected={checked}>
      <RadioControl
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        disabled={disabled}
        data-error={error}
        aria-invalid={error}
        aria-labelledby={description ? labelId : undefined}
        aria-describedby={description ? descriptionId : undefined}
      />
      {description ? (
        <TextStack>
          <LabelText id={labelId}>{label}</LabelText>
          <Description id={descriptionId}>{description}</Description>
        </TextStack>
      ) : (
        label
      )}
    </Label>
  );
}
